import React from 'react';
import { Box, Typography } from '@mui/material';
import { acme } from '../../theme/acmeTheme';

export default function AuthSeparator({ label = 'OR' }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%', my: 0.5 }}>
      <Box sx={{ flex: 1, height: '1px', backgroundColor: acme.colors.border }} />
      <Typography sx={{ fontSize: '0.6875rem', color: acme.colors.mutedForegroundSolid, letterSpacing: '0.08em' }}>
        {label}
      </Typography>
      <Box sx={{ flex: 1, height: '1px', backgroundColor: acme.colors.border }} />
    </Box>
  );
}
